import React from "react";
import "./PlayroomDetails.scss";

import playroomDetailsImage from "../../../assets/images/playroom/playroom18.jpg";
import LazyImage from "../../LazyImage/LazyImage";

export default function PlayroomDetails({ t }) {
  return (
    <div className="playroom-details">
      <div className="playroom-details__image">
        <LazyImage src={playroomDetailsImage} alt="Playroom details image" />
      </div>
      <div className="playroom-details__content">
        <h1>{t("playroom_title")}</h1>
        <p>{t("playroom_description")}</p>
      </div>
    </div>
  );
}
